export const CurrencyRow = ({ items, shadow = true, hover = true }) => (
  // <div className="grid grid-cols-1 ">
  <div
    className={`px-3 py-2 ${
      shadow ? "shadow-noMoneyShadow " : ""
    } bg-white rounded-full`}
  >
    <div className="flex ">
      {items.map((currency, index) => (
        <span
          key={currency.code}
          className={`w-full  flex  justify-center items-center space-x-1 ${
            hover && "hover:bg-gray-50"
          }${index !== items.length - 1 ? "border-r" : " "}`}
        >
          <img
            src={currency.flag}
            alt="currency"
            className="w-[15.16px]  h-[15.53px] "
          />
          <span className="font-geomanistBold text-xs text-blackShade">
            {currency.code}
          </span>
        </span>
      ))}
    </div>
  </div>
  // </div>
);
